import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { UserService, User } from '../../services/user.service';
import { ProfileService } from '../../services/profile.service';
import { NotificationService } from '../../services/notification.service';
import { TranslateService } from '@ngx-translate/core';
import { FormArray, FormGroup, FormBuilder } from "@angular/forms";
import { FileTypeService } from '../../services/fileType.service';
import { Observable, combineLatest } from 'rxjs';
import { AuditTrailService } from '../../services/audittrail.service';

var dateFormat = require('dateformat');


@Component({
  selector: 'nestas-audittrail',
  templateUrl: './audittrail.component.html',
  styleUrls: ['./audittrail.component.scss']
})
export class AuditTrailComponent implements OnInit {
  steps = [];
  me = new User();
  fileTypes = {
    display: [],
    all: []
  }
  templates = [];

  allContractors = [];
  profile;
  allTypes = [];
  filteredTypes: Observable<User[]>[] = [];
  filteredRooms: Observable<User[]>[] = [];
  filteredContractors: Observable<User[]>[] = [];
  form: FormGroup;
  pid;
  file;
  fileDetails;
  currentFilter;
  showMineOnly = false;
  done = false;
  limit = 0;
  offset = 0;
  lastRequestLength = 0;

  newContractor = {
    name: '',
    email: '',
    phone: ''
  }

  modal = {
    viewDetail: false,
    details: null
  };

  constructor(private _auditTrailService: AuditTrailService,
    private _router: Router, private _user: UserService,
    private _profile: ProfileService,
    private _notification: NotificationService, public translate: TranslateService, private formBuilder: FormBuilder,
    public fileTypeService: FileTypeService,
    private _route: ActivatedRoute) {
    this.steps.push({ name: [translate.instant('TOOLBAR.STEP.TEMPLATE')], ref: ["template"] })
  }

  ngOnInit() {
    this.form = this.formBuilder.group({
      items: this.formBuilder.array([]),
      allSelected: false
    });

    if (!this._user.isLoggedIn()) {
      this._router.navigate([''], { queryParams: { redirect: 'template' } });
    } else {
      this._route.params.subscribe(params => {
        this.pid = params.pid;
        this.file = params.file;
        this.offset = 0;
        this.limit = this._auditTrailService.LIMIT;
        console.log("params", params);

        var proms = [];

        proms.push(this._profile.me());

        combineLatest(proms).subscribe(ret => {
          this.profile = ret[0];
          this.populateTable();
        });

      });
    }
  }

  hideCompanyTrails(ft) {
    //this.populateTable();
    //}
    //let res = this.showMineOnly && (!ft.user || ft.user._id.toString() != this.profile._id);
    //console.log("res", res, this.showMineOnly, ft, this.profile._id);
    //return res;
  }

  cancel() {
    let qp = { 'tabindex': '0' };
    return this._router.navigate(['pid', this.pid], { queryParams: qp });
  }

  filterTemplates(filter) {
    //console.log("filter templates", filter);
    this.populateTable(filter);
  }

  get items(): FormArray {
    return this.form.get('items') as FormArray;
  }

  formatDict(d) {
    let out = "";
    Object.getOwnPropertyNames(d).forEach(x => {
      out += x + " = " + d[x] + "\n";
    });
    //console.log("format dict", out);
    return out;
  }

  addPropertiesArray2(o) {
    let res = [];
    let props = Object.getOwnPropertyNames(o[0]);
    //console.log(o, props);
    for (let prop of props) {
      if (prop.toLowerCase().indexOf('id') == -1) {
        if (o.length > 1) {
          res.push([prop, o[0][prop], o[1][prop]]);
        } else {
          res.push([prop, o[0][prop], '']);
        }
      }
    }
    return res;
  }

  formatAddress(value) {
    if (!value) return [];
    const fields = ['address', 'city', 'country', 'zip'];
    let res = [];
    fields.forEach(x => {
      //console.log(value, x);
      if (value.length == 2) {
        res.push([x, this.formatField(x, value[0][x]), this.formatField(x, value[1][x])]);
      } else {
        res.push([x, this.formatField(x, value[0][x]), ""]);
      }
    })
    //console.log('format address', value, res);
    return res;
  }

  formatField(field, v) {
    const datefields = ['trialExpires', 'deadline', 'updatedAt', 'construction', 'date', 'uploaded', 'notifications'];
    if (datefields.indexOf(field) != -1) {
      try {
        return dateFormat(v, "dd/mm/yyyy");
      } catch (e) {
        return v;
      }
    } else {
      if (v == null) v = "";
      return v;
    }
  }

  isId(x) {
    console.log(x, x.length == 24);
    return isNaN(x) && x.length == 24;
  }

  formatDiff(diff, id, reason) {
    let res = this.formatDiffInner(diff, id, reason);
    let isAdmin = this._user.isAdmin;
    //console.log(res);
    res = res.filter(x => (x[1] != "" || x[1] != x[2]));
    //console.log(res);
    if (isAdmin) return res;
    res = res.filter(x => x[0] != 'img' && !this.isId(x[1]) && !this.isId(x[2]));
    return res;
  }

  formatDiffInner(diff, id, reason) {
    const skiplist = ['_id', '__v', '_t', 'img'];

    //console.log(diff, id, reason);
    let out = [];
    Object.getOwnPropertyNames(diff).forEach(x => {
      if (skiplist.indexOf(x) != -1) {
        return;
      }

      if (x == 'content') {
        out.push([x, this.formatField(x, diff[x].text), '']);
      }
      else if (x == 'PID') {
        //console.log("PID", diff[x]);
        out.push([x, this.formatField(x, diff[x].text), '']);
      }
      else if (x == 'img') {
        //console.log("img", diff[x]);
        out.push([x, this.formatField(x, diff[x]), '']);
      }
      else if (x == 'address') {
        //console.log("address", this.formatAddress(diff[0]));
        out = out.concat(this.formatAddress(diff[x]));
      }
      else if (x == 'notifications') {
        //console.log("x", x, diff[x][0]);
        if (diff[x][0] && diff[x][0]?.targetdate) {
          out.push([x,
            this.formatField(x, diff[x][0].targetdate[0]),
            this.formatField(x, diff[x][0].targetdate[1])]);
        }
      }
      else if (x == 'transferTo') {
        let transfer = diff[x];
        if (transfer.details) {
          let keys: string[] = Object.getOwnPropertyNames(transfer.details).filter(x => skiplist.indexOf(x) != -1);
          //console.log('transfer to', transfer.details, keys);
          for (let k of keys) {
            if (transfer.details && transfer.details[k] && transfer.details[k][0]) {
              Object.getOwnPropertyNames(transfer.details[k][0]).forEach(y => {
                out.push([x, y, this.formatField(x, transfer.details[k][0][y])]);
              });
            }
          }
        }
        if (transfer.pending) {
          return out.push(['pending', this.formatField(x, transfer.pending[0]), transfer.pending[1]]);
        }
      }
      else if (x == 'version') {
        let version = diff[x];
        if (version[0]) {
          let keys: string[] = Object.getOwnPropertyNames(version[0]).filter(x => skiplist.indexOf(x) != -1);
          //console.log('version', keys);
          for (let k of keys) {
            if (version[0] && version[0][k]) {
              Object.getOwnPropertyNames(version[0][k]).forEach(y => {
                if (y == 'files') {
                  out = out.concat(this.addPropertiesArray2(version[0][k][y]));
                } else {
                  out.push([y, this.formatField(y, version[0][k][y]), '']);
                }
              });
            }
          }
        }
        //return;
      }
      else if (diff[x].length == 2) {
        return out.push([x, this.formatField(x, diff[x][0]), this.formatField(x, diff[x][1])]);
      } else if (diff[x].length == 1) {
        return out.push([x, '', this.formatField(x, diff[x][0])]);
      }
    });
    //console.log(out);
    return out;
  }

  addRowCtrls(i: number, template?: any) {
    if (this.items.length <= i) {
      //console.log("add row", this.items.length, i);
      this.items.push(this.formBuilder.group({
        selection: [false, []],
        name: [template ? template.name : "", []],
        description: [template ? template.description : "", []],
        type: [template ? template.type : "", []],
        room: [template ? template.room : "", []],
      }));

    } else {
      //console.log("row", this.items.length, i);
      //console.log("has contractor reuse", i, template && template, template && template.contractor ? template.contractor.name.length > 0 : false);
      ['name', 'description', 'type', 'room'].forEach(x => {
        this.items.at(i).get(x).setValue(template ? template[x] : "");
      });
    }

  }


  visit(ft) {
    console.log("visit", ft, ft.collectionName);
    if (ft.collectionName == 'File') {
      return this._router.navigate(['file', ft.collectionId, ft.contextId]);
    }
    if (ft.collectionName == 'Document') {
      return this._router.navigate(['file', ft.collectionId, ft.contextId]);
    }
    if (ft.collectionName == 'PID') {
      return this._router.navigate(['pid', ft.collectionId]);
    }
    if (ft.collectionName == 'Dashboard') {
      return this._router.navigate(['pid', ft.collectionId]);
    }
  }

  visitContext(ft) {
    console.log("visit pid", ft);
    if (ft.collectionName == 'File') {
      return this._router.navigate(['pid', ft.contextId]);
    }
  }


  loadMore() {
    this.offset += this._auditTrailService.LIMIT;
    this.populateTable();
  }

  showLoadMore(){
    return this.lastRequestLength == this._auditTrailService.LIMIT;
  }

  tryTranslate(domain, term){
    let key = domain + '.' + term.toUpperCase();
    let res = this.translate.instant(key);
    if (res == key) return term;
    return res;
  }

  populateTable(q?: string) {
    this.done = false;
    let baseI = this.items.length;
    
    this._auditTrailService.getMine(this.showMineOnly, q, this.pid, this.file, this.offset, this.limit)
      .subscribe(
        (templates: any) => {
          this.lastRequestLength = templates.length;
          templates.forEach((x, i) => {

            let fields = x.reason ? x.reason.split(':') : [""];

            x.url = null;

            x.reason = this.tryTranslate('AUDIT_ACTION', fields[0]);
            x.name = fields[1];
            x.context = fields.length > 2 ? fields[2] : "";
            x.contextId = fields.length > 3 ? fields[3] : null;
            x.collectionName = this.tryTranslate('DATA', x.collectionName);
            x.diffs = this.formatDiff(x.diff, x._id, x._reason);

            this.addRowCtrls(baseI + i, x);
          });
          this.templates = this.templates.concat(templates);

          if (this.currentFilter) {
            this.filterTemplates(this.currentFilter);
          }
          this.done = true;
        },
        this._notification.errorServer
      );
  }
}

